/**
 * Calculator Events Handler
 * Handles event listeners for calculator pages to comply with CSP policy
 */

document.addEventListener('DOMContentLoaded', function() {
    // Handle showLoader onclick events
    const showLoaderButtons = document.querySelectorAll('[data-action="showLoader"]');
    showLoaderButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            showLoader();
        });
    });

    // Handle reload calculator button
    const reloadCalculatorButtons = document.querySelectorAll('[data-action="reloadCalculator"]');
    reloadCalculatorButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            window.location.reload(true);
        });
    });

    // Handle scenario planner form changes
    const scenarioPlannerForm = document.querySelector('[data-calculator="scenario-planner"]');
    if (scenarioPlannerForm) {
        scenarioPlannerForm.addEventListener('change', function() {
            processChange();
        });
        scenarioPlannerForm.addEventListener('keyup', function() {
            processChange();
        });
    }

    // Handle salary options via event delegation
    document.addEventListener('click', function(e) {
        if (e.target && (e.target.classList.contains('salary_option') || e.target.closest('.salary_option'))) {
            const salaryOption = e.target.closest('.salary_option');
            if (salaryOption) {
                const drawdownRate = parseFloat(salaryOption.getAttribute('data-drawdown-rate'));
                if (typeof adjustDrawdown === 'function') {
                    adjustDrawdown(drawdownRate);
                }
            }
        }
    });

    // Handle lumpsum input validation (withdrawal calculator)
    const lumpsumInputs = document.querySelectorAll('[data-validate="lumpsum"]');
    lumpsumInputs.forEach(input => {
        input.addEventListener('keyup', function() {
            const maxValue = parseFloat(this.getAttribute('data-max'));
            const minValue = parseFloat(this.getAttribute('data-min')) || 0;
            
            if (this.value > maxValue) {
                this.value = null;
            }
            if (this.value < minValue) {
                this.value = null;
            }
        });
    });

    // Handle drawdown rate input validation
    const drawdownInputs = document.querySelectorAll('[data-validate="drawdown"]');
    drawdownInputs.forEach(input => {
        input.addEventListener('keyup', function() {
            const maxValue = parseFloat(this.getAttribute('data-max')) || 17.5;
            const minValue = parseFloat(this.getAttribute('data-min')) || 2.5;
            
            if (this.value > maxValue) {
                this.value = maxValue;
            }
            if (this.value < minValue) {
                this.value = minValue;
            }
        });
    });

    // Handle inflation rate input validation
    const inflationInputs = document.querySelectorAll('[data-validate="inflation"]');
    inflationInputs.forEach(input => {
        input.addEventListener('keyup', function() {
            const maxValue = parseFloat(this.getAttribute('data-max')) || 17.5;
            const minValue = parseFloat(this.getAttribute('data-min')) || 0;
            
            if (this.value > maxValue) {
                this.value = maxValue;
            }
            if (this.value < minValue) {
                this.value = minValue;
            }
        });
    });
});

/**
 * Show loader - fallback function if not defined elsewhere
 */
function showLoader() {
    // Check if showLoader is already defined globally
    if (typeof window.showLoaderCustom === 'function') {
        window.showLoaderCustom();
    } else {
        // Default implementation - add a loading spinner or indicator
        console.log('Loading...');
    }
}
